export function EntityLoader(entity, entityName) {
    this.entity = entity;
    this.entityName = entityName;
    this.status = { controller: null, loading: false };
}

EntityLoader.prototype.getUrl = function() { return ""; };

EntityLoader.prototype.load = function() {
    if (this.status.loading) {
        this.status.controller.abort();
    }

    this.entity.splice(0, this.entity.length);
    
    this.status = (() => {
        const status = { controller: new AbortController(), loading: true };
        const signal = status.controller.signal;
        fetch(this.getUrl(...arguments), {signal}).then(response => {
            response.json().then(data => {
                data[this.entityName].forEach(element => { this.entity.push(element); });
                status.loading = false;
            })
        }).catch(error => {
            console.log(error);
            status.loading = false;
        });
        return status;
    })();
}

const host = 'https://www.waterfootprintassessmenttool.org/nessie/entities';
const countriesPath = 'countries.jsp?format=json&cors=true';
const basinsPath = 'basins.jsp?format=json&cors=true';
const cropsPath = 'crops.jsp?format=json&cors=true';
const worldCropsPath = 'world-crops.jsp?format=json&cors=true';
const countryCropsByCountryPath = 'country-crops.jsp?format=json&cors=true'; // pie chart and table
const countryCropsByCropPath = 'country-crops.jsp?format=json&cors=true'; // bar chart
const basinCropsByBasinPath = 'basin-crops.jsp?format=json&cors=true'; // pie chart and table
const basinCropsByCropPath = 'basin-crops.jsp?format=json&cors=true'; // bar chart
const countryBasinCropsPath = 'country-basin-crops.jsp?format=json&cors=true'; // sustainability table and response table

export const countries = [];              // https://www.waterfootprintassessmenttool.org/nessie/entities/countries.jsp
export const basins = [];                 // https://www.waterfootprintassessmenttool.org/nessie/entities/basins.jsp
export const crops = [];                  // https://www.waterfootprintassessmenttool.org/nessie/entities/crops.jsp
export const worldCrops = [];             // https://www.waterfootprintassessmenttool.org/nessie/entities/world-crops.jsp
export const countryCropsByCountry = [];  // https://www.waterfootprintassessmenttool.org/nessie/entities/country-crops.jsp?country=642
export const countryCropsByCrop = [];     // https://www.waterfootprintassessmenttool.org/nessie/entities/basin-crops.jsp?basin=118
export const basinCropsByBasin = [];      // https://www.waterfootprintassessmenttool.org/nessie/entities/country-crops.jsp?crop=15
export const basinCropsByCrop = [];       // https://www.waterfootprintassessmenttool.org/nessie/entities/basin-crops.jsp?crop=15
export const countryBasinCrops = [];

export const loadBaseEntities = function() {
    fetch(`${host}/${countriesPath}`).then(response => {
        response.json().then(data => {
            data.countries.forEach(element => { countries.push(element); });
        })
    }).catch(error => {
        console.log(error);
    });

    fetch(`${host}/${basinsPath}`).then(response => {
        response.json().then(data => {
            data.basins.forEach(element => { basins.push(element); });
        })
    }).catch(error => {
        console.log(error);
    });
    
    fetch(`${host}/${cropsPath}`).then(response => {
        response.json().then(data => {
            data.processes.forEach(element => { crops.push(element); });
        })
    }).catch(error => {
        console.log(error);
    });
    
    fetch(`${host}/${worldCropsPath}`).then(response => {
        response.json().then(data => {
            data.worldCrops.forEach(element => { 
                element.value = element.blueWFt + element.greenWFt + element.greyWFt;
                worldCrops.push(element); 
            });
        })
    }).catch(error => {
        console.log(error);
    });
}

export const countryCropsByCountryLoader = new EntityLoader(countryCropsByCountry, "countryCrops");
countryCropsByCountryLoader.getUrl = function(countryId) {
    return `${host}/${countryCropsByCountryPath}&country=${countryId}`;
}

export const countryCropsByCropLoader = new EntityLoader(countryCropsByCrop, "countryCrops");
countryCropsByCropLoader.getUrl = function(cropId) {
    return `${host}/${countryCropsByCropPath}&crop=${cropId}`;
}

export const basinCropsByBasinLoader = new EntityLoader(basinCropsByBasin, "basinCrops");
basinCropsByBasinLoader.getUrl = function(basinId) {
    return `${host}/${basinCropsByBasinPath}&basin=${basinId}`;
}

export const basinCropsByCropLoader = new EntityLoader(basinCropsByCrop, "basinCrops");
basinCropsByCropLoader.getUrl = function(cropId) {
    return `${host}/${basinCropsByCropPath}&crop=${cropId}`;
}

export const countryBasinCropsLoader = new EntityLoader(countryBasinCrops, "countryBasinCrops");
countryBasinCropsLoader.getUrl = function(countryId, basinId, cropId) {
 return (countryId != null)? `${host}/${countryBasinCropsPath}&country=${countryId}&crop=${cropId}`:
        (basinId != null)? `${host}/${countryBasinCropsPath}&basin=${basinId}&crop=${cropId}`:
        `${host}/${countryBasinCropsPath}&crop=${cropId}`;
}

export function getCountry(countryID) {
    for (const country of countries) {
        if (country.countryID == countryID) {
            return country;
        }
    }
    return null;
}

export function getBasin(basinID) {
    for (const basin of basins) {
        if (basin.basinID == basinID) {
            return basin;
        }
    }
    return null;
}

export function getCrop(cropID) {
    for (const crop of crops) {
        if (crop.cropID == cropID) {
            return crop;
        }
    }
    return null;
}

